import React from "react";
import { Spin } from "antd";
import { useZones } from "../../hook/useZones";
import Select from "./Select";

type Props = {
  value?: string;
  onChange?: (val: string) => void;
};

const ZoneSelect = ({ value, onChange }: Props) => {
  const { data: zones, isLoading } = useZones();

  // if (isLoading) return <Spin />;

  return (
    <Select
      data={zones}
      placeholder='เขตทั้งหมด'
      value={value}
      onChange={onChange}
      style={{ width: "100%" }}
    />
  );
};

export default ZoneSelect;
